import { randomNumberUtil } from 'packages/src'

export const OPTION_MODAL_TYPES = {
  GENDER: 'GENDER',
  HEIGHT: 'HEIGHT',
  WEIGHT: 'WEIGHT',
  BODY_TYPE: 'BODY_TYPE',
  FITNESS_LEVEL: 'FITNESS_LEVEL',
  INTEREST_FOCUS: 'INTEREST_FOCUS',
  WORKOUT_DURATION_GOAL: 'WORKOUT_DURATION_GOAL',
  INJURIES: 'INJURIES',
  FREQUENCY: 'FREQUENCY',
  GOAL_OBSTACLE: 'GOAL_OBSTACLE',
  DAILY_CALORIE_INTAKE: 'DAILY_CALORIE_INTAKE',
  DESIRED_OUTCOME: 'DESIRED_OUTCOME',
  DIET_TYPE: 'DIET_TYPE',
  GOAL: 'GOAL',
  WEEKLY_GOAL: 'WEEKLY_GOAL',
  GYM_ACCESS: 'GYM_ACCESS',
  COACH_INTENSITY_LEVEL: 'COACH_INTENSITY_LEVEL',
  BIRTHDAY: 'BIRTHDAY',
  SUBSCRIPTION: 'SUBSCRIPTION',
  PAYMENT: 'PAYMENT',
  TRAINING_TIME: 'TRAINING_TIME'
}

export const PROFILE_NAME_ALREADY_IN_USE = 'PROFILE_NAME_ALREADY_IN_USE'

export const PROFILE_LOCAL_STORAGE_KEY = {
  EMAIL: 'email',
  PROFILE_DATA: 'profileData',
  PROFILE_FITNESS_DATA_MODAL_SHOWN_AT: 'profileFitnessDataModalShownAt'
}

// 120-240 seconds
export const PROFILE_FITNESS_DATA_MODAL_DELAY_IN_SECONDS = randomNumberUtil(120, 240) * 1000

// 2-5 seconds
export const PROFILE_FITNESS_DATA_MODAL_DELAY_APP_ROUTE_IN_SECONDS = randomNumberUtil(2, 5) * 1000

// 1-3 seconds
export const PROFILE_FITNESS_DATA_MODAL_NEW_PROFILE_WITH_INCOMPLETE_DATA_IN_SECONDS = randomNumberUtil(1, 3) * 1000
